import { readableInkOn } from "@/lib/color-contrast"

/** Text colour (fixed charcoal `rgb(52 57 59)` or white) with the higher WCAG contrast on `hex`. */
export function readableTextOn(hex: string): string {
  return readableInkOn(hex).text
}

/**
 * Halo colour for a label drawn on `hex`, or null when the text already reaches 4.5:1.
 *
 * The market colours are fixed (owner decision D6), so for mid-tones where neither charcoal nor
 * white reaches AA the label gets an opposite-colour halo instead. The halo is the other of
 * charcoal/white, so text against halo is always well above 4.5:1.
 */
export function readableHaloOn(hex: string): string | null {
  const ink = readableInkOn(hex)
  return ink.needsHalo ? ink.halo : null
}

/** Attributes for an SVG `<text>` carrying the halo; empty when no halo is needed. */
export function svgHaloProps(hex: string) {
  const halo = readableHaloOn(hex)
  if (!halo) return {}
  return {
    paintOrder: "stroke" as const,
    stroke: halo,
    strokeWidth: 3,
    strokeLinejoin: "round" as const,
  }
}

/** `text-shadow` for HTML labels carrying the halo; undefined when no halo is needed. */
export function haloTextShadow(hex: string): string | undefined {
  const halo = readableHaloOn(hex)
  if (!halo) return undefined
  return [
    `1px 0 0 ${halo}`,
    `-1px 0 0 ${halo}`,
    `0 1px 0 ${halo}`,
    `0 -1px 0 ${halo}`,
    `0 0 3px ${halo}`,
  ].join(", ")
}
